import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  SearchResultViewModel,
  SearchViewModel,
} from '../../shared/models/search-view.model';
import { Product } from '../../../shared/models/product.model';
import { ProductAlternativeTypeEnum } from '../../../product-detail/models/product-alternative';
import { UsfProductCardModeEnum } from '../../../shared/constants/usf-product-card-mode.enum';
import { SearchModeConfig } from '../../models/search-mode-config.model';
import { PowerReviewProductState } from '@usf/ngrx-product/lib/models/power-review-product-state.model';
import { PowerReviewRollupModel } from '@usf/ngrx-product/lib/models/power-review-product.model';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent implements OnInit {
  @Input() pwrRatingStarsMap: Map<string, PowerReviewRollupModel>;
  @Input() searchViewModel: SearchViewModel;
  @Input() mode: UsfProductCardModeEnum;
  @Input() modeConfig: SearchModeConfig;
  @Input() pageModes = UsfProductCardModeEnum;
  @Input() replacementBaseProduct: SearchResultViewModel;
  @Input() isTouchExperience: boolean;
  @Input() overrideExclusiveSelection = false;
  @Input() isGuestUser = false;
  @Input() itemsSelectable: boolean;
  @Input() topSellers: ProductDetailViewModel[];
  @Input() itemHeights: number[];
  @Input() headerText: string;

  @Input() useCoveoTopSellers = false;
  @Input() coveoTopSellers: ProductDetailViewModel[];

  @Output() selectionChange = new EventEmitter<Product[]>();
  @Output() scrolledIndexChange = new EventEmitter();

  @ViewChild(CdkVirtualScrollViewport) viewport: CdkVirtualScrollViewport;

  alternativeTypes = ProductAlternativeTypeEnum;

  constructor() {}

  ngOnInit(): void {
    window.addEventListener('resize', () => {
      this.viewport?.checkViewportSize();
    });
  }

  trackProduct(index, product) {
    return product ? index : undefined;
  }

  /***
   * DO NOT USE IN EXCLUSIVE MODE
   */
  updateSelection(selectedProduct: SearchResultViewModel) {
    if (
      (this.mode !== UsfProductCardModeEnum.replacementSearch &&
        this.mode != UsfProductCardModeEnum.exceptionSearch &&
        this.mode != UsfProductCardModeEnum.cartReplacementSearch) ||
      this.overrideExclusiveSelection
    ) {
      const selectedProducts = this.searchViewModel.listProducts.filter(
        product => product.selected,
      );
      this.notifySelectionChange(selectedProducts);
    } else {
      this.updateSelectionExclusive(selectedProduct);
    }
  }

  /***
   * USE ONLY FOR EXCLUSIVE MODE ONLY
   */
  updateSelectionExclusive(selectedProduct: SearchResultViewModel) {
    if (
      this.mode === UsfProductCardModeEnum.replacementSearch ||
      this.mode === UsfProductCardModeEnum.exceptionSearch ||
      this.mode === UsfProductCardModeEnum.cartReplacementSearch
    ) {
      // Reset all other selections to provide an 'exclusive' selection mode
      this.resetSelection(selectedProduct);
      this.notifySelectionChange([selectedProduct]);
    }
  }

  notifySelectionChange(selectedProducts: SearchResultViewModel[]) {
    this.selectionChange.emit(selectedProducts.filter(p => p.selected));
  }

  resetSelection(selectedProduct: SearchResultViewModel) {
    this.searchViewModel?.listProducts
      .filter(
        item =>
          item.productNumber != selectedProduct.productNumber && item.selected,
      )
      .forEach(item => (item.selected = false));
  }

  nextBatch($event: number) {
    this.scrolledIndexChange.emit($event);
  }

  getViewport() {
    return this.viewport;
  }
}
